import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "react-responsive";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import HeaderContent from "./HeaderContent";

const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isTab",
})(({ theme, open, isTab }) => ({
  zIndex: theme.zIndex.drawer + 1,
  ...(isTab
    ? {}
    : open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
    }),
  ...(!isTab &&
    !open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${84}px)`,
  }),
}));

const Topnavbar = ({
  dataItems,
  open,
  setCompany,
  setOpen,
  setHistoySections,
  HistoySections,
  setopenDialog,
  setisDefaultPage,
  page,
  toggleDrawer,
}) => {
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        style={{ backgroundColor: "white", boxShadow: "none", zIndex: "1" }}
        open={open}
        isTab={isTab}
      >
        <Toolbar
          style={{
            justifyContent: "space-between",
            paddingTop: "20px",
            alignItems: "center",
            paddingBottom: "20px",
            height: "72px",
            background: "white",
            boxShadow: "0 4px 8px rgba(255, 255, 255, 0.2)",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            style={{
              color: "#253978",
              fontSize: "24px",
              fontWeight: "700",
              textAlign: "left",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              alignContent: "center",
            }}
            noWrap
            component="div"
          ></Typography>
          <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2 }}>
            <HeaderContent />
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Topnavbar;
